import React, { useState } from 'react'
import { Spin, Row, Col } from 'antd'
import { useSelector, useDispatch } from 'react-redux'
import IntlMessages from '../../util/IntlMessages'
import PaymentPanelActionComplete from './PaymentPanelActionComplete'
import PaymentPanelAction from './PaymentPanelAction'
import PaymentPanelSummary from './PaymentPanelSummary'

const PaymentPanel = props => {
  const { outletName, registerName, outletid } = props
  const {
    storeCreditPerm,
    returnStoreCredit,
    getLaySalePerm,
    getAccountSalePerm,
    allowPrint,
    allowPrintNote,
    allowDiscountShow,
    allowNextUser
  } = props
  const getCurrData = props.getCurrData
    ? props.getCurrData
    : {
        currencyCode: '',
        currencyName: '',
        currencySymbol: ''
      }
  const getIsPaymentPanelLoading = useSelector(
    ({ MainSale }) => MainSale.getIsPaymentPanelLoading
  )
  const getIsPaymentPanelActionCompleteActive = useSelector(
    ({ MainSale }) => MainSale.getIsPaymentPanelActionCompleteActive
  )
  const cartMainClass = useSelector(({ MainSale }) => MainSale.cartMainClass);

  return (
    <div className='payment-panel Invoice-Container-div'>
      <Spin
        tip={<IntlMessages id='common.resource.loading' />}
        spinning={getIsPaymentPanelLoading}
        size='large'
      >
        <Row>
          <Col md={12} sm={24} xs={24} className={`Order-Invoice-div ${cartMainClass}`}>
            <PaymentPanelSummary getCurrData={getCurrData} />
          </Col>

          <Col md={12} sm={24} xs={24} className='Amount-Pay-div'>
            {getIsPaymentPanelActionCompleteActive ? (
              <PaymentPanelActionComplete
                getCurrData={getCurrData}
                outletName={outletName}
                registerName={registerName}
                allowPrint={allowPrint}
                allowPrintNote={allowPrintNote}
                allowDiscountShow={allowDiscountShow}
                allowNextUser={allowNextUser}
              />
            ) : (
              <PaymentPanelAction
                getCurrData={getCurrData}
                storeCreditPerm={storeCreditPerm}
                returnStoreCredit={returnStoreCredit}
                getLaySalePerm={getLaySalePerm}
                getAccountSalePerm={getAccountSalePerm}
                outletid={outletid}
                allowPrint={allowPrint}
              />
            )}
          </Col>
        </Row>
      </Spin>
    </div>
  )
}

export default PaymentPanel
